import './App.css';
import OpenX from './webgl';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import { persistor, store } from './redux/store';
import { Marketplace } from './marketPlace/marketPlace';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { CreateAccount } from './marketPlace/pages/createAccount';
import { HomePage } from './homePage/homePage';
import { Navbar } from './components/navBar/navBar';
import { Footer } from './components/Footer/Footer';
import { AboutPage } from './about/about';
import { SignIn } from './marketPlace/pages/signIn';
import { ForgotPassword } from './marketPlace/pages/forgotPassword';
import { ForgotPasswordOtp } from './marketPlace/pages/forgotPasswordOtp';
import { NewPassword } from './marketPlace/pages/newPassword';
import { NavBarMarketPlace } from './components/navBarMarketPlace';
import { SidebarProfile } from './components/SideBar';
import { StoreNavbar } from './components/storeNavbar';
import { StoreCustomRequestForm } from './stores/storeCustomRequest';
import { ChooseTemplate } from './stores/chooseTemplate';
import { ContactPage } from './contact';
import { FAQSection } from './faq';
import { StoreWelcomeScreen } from './stores/welcomePage';
import { BoutiqueLayout } from './stores/storeProductLayout';
import { BoutiqueInfo } from './stores/storeInfo';
import { AddStoreProducts } from './stores/storeProducts';
import { Congratulation } from './CongratulationPage';
import { BuyerProfilePage } from './buyer/buyer-profile';
import { BuyerNotificationPage } from './buyer/buyer-notification';
import BuyerCartPage from './buyer/buyer-cart';
import BuyerFavouritePage from './buyer/buyer-favourite';
import BuyerOrdersPage from './buyer/buyer-orders';
import BuyerSettingsPage from './buyer/buyer-settings';
import styles from './style.module.css';
import BuyerCheckOutPage from './buyer/buyer-checkout';
import BuyerOrderIdPage from './buyer/buyer-orderId';
import { CustomizeStoreProducts } from './stores/customizeStore';
import { PreviewStoreProducts } from './stores/storePreview';
import { Create3DModelFromImage } from './components/ImageConversion';
import { SellerDashboardHome } from './widgets/SellerDashboard/HomeSellerDashboard';
import { SellerDashboardLayout } from './components/SellerDashboardLayout';
import { ProductList } from './widgets/SellerDashboard/SellerProduct';
import { VerifyUser } from './marketPlace/pages/verifyUser';
import { AnalyticsDashboardPage } from './widgets/SellerDashboard/SellerAnalytics';
import { SellerProfilePage } from './widgets/SellerDashboard/SellerProfile/profile';
import { EditSellerProfilePage } from './widgets/SellerDashboard/SellerProfile/edit';
import { SellerSettingsPage } from './widgets/SellerDashboard/SellerSettings';
import { ViewProduct } from './widgets/SellerDashboard/SellerProduct/ViewProduct';
import { EditProduct } from './widgets/SellerDashboard/SellerProduct/EditProduct';
import { OrderManagement } from './widgets/SellerDashboard/SellerOrderManagement';
import { SellerStore } from './widgets/SellerDashboard/SellerStore';
import { BuyerReviewPage } from './buyer/buyer-review';
import { BuyerRatePage } from './buyer/buyer-rate';
import { TabBar } from './components/TabBar';
import { ProtectedRoute } from './marketPlace/pages/protectedRoute';
import { MarketPlaceStores } from './widgets/marketPlaceStores';
import { FailedStoreMessage } from './components/FailedStore';


const MainLayout: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  return (
    <>
      <Navbar />
      {children}
      <Footer />
    </>
  );
};

const StoreLayout: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  return (
    <>
      <StoreNavbar />
      {children}
    </>
  );
};

const NoLayoutPages: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  return <>{children}</>;
};

const MarketPlacePage: React.FC<{ children?: React.ReactNode }> = ({ children }) => {
  return (
    <>
      <NavBarMarketPlace />
      {children}
    </>
  );
};

const BuyerAccountLayout: React.FC<{ children?: React.ReactNode }> = ({ children }) => {
  return (
    <>
      <div>
        <NavBarMarketPlace />
        <div className={styles.sideBar}>
          <SidebarProfile />
          <main className={styles.content}>
            <div>{children}</div>
          </main>
        </div>
        <TabBar />
      </div>
    </>
  );
};

function App() {
  return (
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <Router>
          <div className="App">
            <Routes>
              {/* Main pages with Navbar and Footer */}
              <Route
                path="/"
                element={
                  <MainLayout>
                    <HomePage />
                  </MainLayout>
                }
              />
              <Route
                path="/about"
                element={
                  <MainLayout>
                    <AboutPage />
                  </MainLayout>
                }
              />
              <Route
                path="/contact"
                element={
                  <MainLayout>
                    <ContactPage />
                  </MainLayout>
                }
              />
              <Route
                path="/faq"
                element={
                  <MainLayout>
                    <FAQSection />
                  </MainLayout>
                }
              />
              {/* Store-related pages with different navbar, no footer */}
              <Route
                path="/create-store"
                element={
                  <ProtectedRoute>
                    <StoreLayout>
                      <StoreWelcomeScreen />
                    </StoreLayout>
                  </ProtectedRoute>
                }
              />
              <Route
                path="/choose-template"
                element={
                  <StoreLayout>
                    <ChooseTemplate />
                  </StoreLayout>
                }
              />
              <Route
                path="/custom-request"
                element={
                  <StoreLayout>
                    <StoreCustomRequestForm />
                  </StoreLayout>
                }
              />
              <Route
                path="/boutique-layout/:templateId"
                element={
                  <StoreLayout>
                    <BoutiqueLayout />
                  </StoreLayout>
                }
              />
              <Route
                path="/add-info/:templateId?"
                element={
                  <StoreLayout>
                    <BoutiqueInfo />
                  </StoreLayout>
                }
              />
              <Route
                path="/add-products/:storeId"
                element={
                  <StoreLayout>
                    <AddStoreProducts />
                  </StoreLayout>
                }
              />
              <Route
                path="/customize-store/:storeId"
                element={
                  <StoreLayout>
                    <CustomizeStoreProducts />
                  </StoreLayout>
                }
              />
              <Route
                path="/preview-store/:storeId"
                element={
                  <StoreLayout>
                    <PreviewStoreProducts />
                  </StoreLayout>
                }
              />
              <Route
                path="/convert-image"
                element={
                  <StoreLayout>
                    <Create3DModelFromImage />
                  </StoreLayout>
                }
              />
              <Route
                path="/congratulations-message"
                element={
                  <StoreLayout>
                    <Congratulation />
                  </StoreLayout>
                }
              />
              <Route
                path="/store-error"
                element={
                  <StoreLayout>
                    <FailedStoreMessage />
                  </StoreLayout>
                }
              />
              {/* Pages with navbar, without footer */}
              <Route
                path="/marketPlace"
                element={
                  <ProtectedRoute>
                    <MarketPlacePage>
                      <Marketplace />
                    </MarketPlacePage>
                  </ProtectedRoute>
                }
              />
              <Route
                path="/openX"
                element={
                  <NoLayoutPages>
                    <OpenX />
                  </NoLayoutPages>
                }
              />
              <Route
                path="/createAccount"
                element={
                  <NoLayoutPages>
                    <CreateAccount />
                  </NoLayoutPages>
                }
              />
              <Route path="/signIn" element={<SignIn />} />
              <Route path="/forgotPassword" element={<ForgotPassword />} />
              <Route path="/forgotPassword-otp" element={<ForgotPasswordOtp />} />
              <Route path="/forgotPassword-newPassword" element={<NewPassword />} />
              <Route path="/verify-user" element={<VerifyUser />} />
              {/* VerifyUser */}
              <Route
                path="/buyer-profile"
                element={
                  <BuyerAccountLayout>
                    <BuyerProfilePage />
                  </BuyerAccountLayout>
                }
              />
              <Route
                path="/buyer-notification"
                element={
                  <BuyerAccountLayout>
                    <BuyerNotificationPage />
                  </BuyerAccountLayout>
                }
              />
              <Route
                path="/buyer-cart"
                element={
                  <BuyerAccountLayout>
                    <BuyerCartPage />
                  </BuyerAccountLayout>
                }
              />
              <Route
                path="/buyer-orders"
                element={
                  <BuyerAccountLayout>
                    <BuyerOrdersPage />
                  </BuyerAccountLayout>
                }
              />
              <Route
                path="/buyer-favourite"
                element={
                  <BuyerAccountLayout>
                    <BuyerFavouritePage />
                  </BuyerAccountLayout>
                }
              />
              <Route
                path="/buyer-settings"
                element={
                  <BuyerAccountLayout>
                    <BuyerSettingsPage />
                  </BuyerAccountLayout>
                }
              />
              <Route
                path="/buyer-checkout"
                element={
                  <BuyerAccountLayout>
                    <BuyerCheckOutPage />
                  </BuyerAccountLayout>
                }
              />
              <Route
                path="/buyer-order/:id"
                element={
                  <BuyerAccountLayout>
                    <BuyerOrderIdPage />
                  </BuyerAccountLayout>
                }
              />
              <Route
                path="/seller-dashboard"
                element={
                  <SellerDashboardLayout>
                    <SellerDashboardHome />
                  </SellerDashboardLayout>
                }
              />
              <Route
                path="/products"
                element={
                  <SellerDashboardLayout>
                    <ProductList />
                  </SellerDashboardLayout>
                }
              />
              <Route
                path="/analytics"
                element={
                  <SellerDashboardLayout>
                    <AnalyticsDashboardPage />
                  </SellerDashboardLayout>
                }
              />
              <Route
                path="/profile"
                element={
                  <SellerDashboardLayout>
                    <SellerProfilePage />
                  </SellerDashboardLayout>
                }
              />
              <Route
                path="/profile/edit"
                element={
                  <SellerDashboardLayout>
                    <EditSellerProfilePage />
                  </SellerDashboardLayout>
                }
              />
              <Route
                path="/preferences"
                element={
                  <SellerDashboardLayout>
                    <SellerSettingsPage />
                  </SellerDashboardLayout>
                }
              />
              <Route
                path="/view/:id"
                element={
                  <SellerDashboardLayout>
                    <ViewProduct />
                  </SellerDashboardLayout>
                }
              />
              <Route
                path="/edit/:id"
                element={
                  <SellerDashboardLayout>
                    <EditProduct />
                  </SellerDashboardLayout>
                }
              />
              <Route
                path="/orders"
                element={
                  <SellerDashboardLayout>
                    <OrderManagement />
                  </SellerDashboardLayout>
                }
              />
              <Route
                path="/store"
                element={
                  <SellerDashboardLayout>
                    <SellerStore />
                  </SellerDashboardLayout>
                }
              />
              <Route
                path="/buyer-review"
                element={
                  <BuyerAccountLayout>
                    <BuyerReviewPage />
                  </BuyerAccountLayout>
                }
              />
              <Route
                path="/buyer-rate/:id"
                element={
                  <BuyerAccountLayout>
                    <BuyerRatePage />
                  </BuyerAccountLayout>
                }
              />
              <Route
                path="/marketPlaceStores/:item"
                element={
                  <MarketPlacePage>
                    <MarketPlaceStores />
                  </MarketPlacePage>
                }
              />
            </Routes>
          </div>
        </Router>
      </PersistGate>
    </Provider>
  );
}

export default App;
